// Estado "selecionado" dos cards de opção (Gateways, Redirecionadores…): roxo
// translúcido, o mesmo tom dos filtros "Todos / PIX / Cartão". O roxo sólido
// (#4c1d95) pesava demais.
export const SELECTED_CLS = "bg-[rgba(139,92,246,0.14)] border-[rgba(139,92,246,0.45)]";
export const UNSELECTED_CLS = "bg-white/[0.02] border-white/[0.06] hover:border-white/[0.12] hover:bg-white/[0.04]";
